// What a send to QuickBooks (POST /api/quickbooks/create-invoices) changes on the
// orders page, and so what the page must refetch once the request settles.
import type { QueryClient } from "@tanstack/react-query";

/**
 * A send marks each invoiced order synced and floors `pending → reviewed`, moves
 * the "sent to QB" count, and may link an account to a QuickBooks customer.
 * Key prefixes, so every orders query on the page (the table and the date tabs)
 * is covered whatever its filter params.
 */
export const QUICKBOOKS_SEND_STALE_KEYS = ["/api/orders", "/api/dashboard/stats", "/api/accounts"] as const;

export function refreshAfterQuickbooksSend(queryClient: QueryClient): void {
  for (const key of QUICKBOOKS_SEND_STALE_KEYS) {
    queryClient.invalidateQueries({ queryKey: [key] });
  }
}
